export default __webpack_public_path__ + "static/media/logo_white.94ca6831.png";